import React, {useEffect, useRef, useState} from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

ChartJS.defaults.font.size = 16;
ChartJS.defaults.font.family = "'Graphik', sans-serif";

function getChartData(index) {
  if (!index) {
    index = 0
  }
  let chartData ={
    labels:
    window.NBIjs.indexRvU.labels,
    datasets:
      [{...window.NBIjs.indexRvU.datasets[index].data}]
  };
  return chartData;
}

function ChartLegend(props) {
  return (
    <div className={'chart-legend' + ((props.className)?' '+props.className:'')}>
      {(Object.values(window.NBIjs.indexRvU.colors)).map((color, index) => {
        return <div className={'item'} key={index}><span className={'dot'} style={{backgroundColor:color}}></span> {window.NBIjs.indexRvU.labels[index+2]}</div>
      })}
    </div>
  );
}
function NBIIndexRvU(props) {

  const [introContent, setIntroContent ] = useState(jQuery('#' + props.args.id + ' .intro.hidden').html());
  const [filterState, setFilter ] = useState({value:0});
  const [chartData, setChartData] = useState(getChartData());
  const [chartOptions, setChartOptions] = useState(
    {
      onResize:onChartResize,
      aspectRatio: 1.25,
      responsive: true,
      plugins: {
        legend: {
          display: false,
        }
      },
      scales: {
        x: {
          grid: {
            color:'#ffffff',
            tickLength: 0,
            tickColor:'#ffffff',
            borderColor:'#ffffff',
            drawOnChartArea:false
          },

          ticks: {
            color:'#ffffff',
            padding:70,
            minRotation:-90,
            maxRotation:-90,
            // aligh:'center'
          },
        },

        y: {
          min:window.NBIjs.indexRvU.datasets[0].data.min,
          max:window.NBIjs.indexRvU.datasets[0].data.max,
          grid: {
            color:'#ffffff',
            drawTicks: true,
            tickLength: 8,
            borderDash:[8,1200],
            borderDashOffset: 0,
            tickColor:'#ffffff',
            borderColor:'#ffffff',
          },
          ticks: {
            color:'#ffffff',
            padding:32,
          },
        }
      }
    }
  );

  function onChartResize() {
    if (!chartRef.current || !chartRef.current.chartArea) {
      return;
    }
    setTimeout(function () {
      setChartData({...chartData,
        datasets:[
          {
            ...chartData.datasets[0],
            inflateAmount:chartRef.current.chartArea.width * 0.02051, //inflate bars so they touch at edges
          },
        ],
      });
      setChartOptions({
        ...chartOptions,
        scales: {
          ...chartOptions.scales,
          x: {
            ...chartOptions.scales.x,
            ticks: {
              ...chartOptions.scales.x.ticks,
              //draw ticks depending on window width
              display: (jQuery(window).width() >= 640)
            }
          }
        }
      })
    })

  }

  function getIntroContent(id) {
    return jQuery(id).html();
  }

  function onFilterChange(value) {
    setFilter({value: value})
  }

  function filterBars() {
    //set filtered out plots into transparent
    setChartData({
      ...chartData,
      datasets:[
        {
          ...chartData.datasets[0],
          data:window.NBIjs.indexRvU.datasets[parseInt(filterState.value)].data.data
        }
      ]
    });
    setChartOptions({
      ...chartOptions,
      scales: {
        ...chartOptions.scales,
        y: {
          ...chartOptions.scales.y,
          min:window.NBIjs.indexRvU.datasets[parseInt(filterState.value)].data.min,
          max:window.NBIjs.indexRvU.datasets[parseInt(filterState.value)].data.max,
        }
      }
    })
  }
  const chartRef = useRef();


  useEffect(() => {
    if (chartRef.current) {
      onChartResize();
    }
  }, []);

  useEffect(() => {
    filterBars();
  }, [filterState]);

  useEffect(() => {
    chartRef.current.update();
    // console.log(chartOptions)
  }, [chartData, chartOptions]);

    return (
      <>
        <div className={'left'}>
          <div className="intro" dangerouslySetInnerHTML={{__html:introContent}} />
          <div className={'chart-filter'}>
            <select value={filterState.value} onChange={(event) => {
              onFilterChange(event.target.value)
            }}>
              {window.NBIjs.indexRvU.datasets.map((dataset, index) => {
                return <option key={index} value={index}>{dataset.label}</option>
              })}
            </select>
          </div>
          <ChartLegend className={'for-wp-desktop'}/>
        </div>
        <div className={'right'}>
          <Bar options={chartOptions} data={chartData} ref={chartRef} />
          <ChartLegend className={'for-wp-mobile'}/>
        </div>
      </>
    );
}

export { NBIIndexRvU }
